export const selectZ3kTargetTemp = (state) => state.z3k_target_temp;
